// Sessions tab — merged Attendance + Appointments + batch manager.
import { useState } from "react";
import { getCurrencySymbol } from "../lib/format";
import { Btn, useToast } from "../ui/primitives";
import { RenewPackageModal, ExtendPackageModal } from "../modals/package";
import { BatchManager } from "./BatchManager";
import { Attendance } from "./Attendance";
import { Appointments } from "./Appointments";

export const Sessions=({clients,setClients,applyClientAndPayment,theme,initialTab,userId,profile,registerBack,attendanceRecords:extRecords,setAttendanceRecords:setExtRecords,appointments,setAppointments})=>{
  const toast=useToast();
  const [tab,setTab]=useState(initialTab||"appointments");
  const [renewNeeded,setRenewNeeded]=useState(null);
  const [showRenew,setShowRenew]=useState(false);
  const [showExtend,setShowExtend]=useState(false);
  const currency=getCurrencySymbol(profile);
  const isDark=theme?.dark;

  const handleRenewNeeded=(client)=>{
    setRenewNeeded(client);
  };

  return(
    <div className="space-y-4">
      <div className="flex gap-1 p-1 rounded-xl" style={{background:isDark?"#1e293b":"#f3f4f6"}}>
        {[{id:"appointments",label:"Appointments"},{id:"attendance",label:"Attendance"},{id:"batches",label:"Batches"}].map(t=>(
          <button key={t.id} onClick={()=>setTab(t.id)}
            className="flex-1 py-2 rounded-xl text-xs font-semibold transition-all"
            style={{background:tab===t.id?(isDark?"#0f172a":"#fff"):"transparent",color:tab===t.id?(theme?.primary||"#0f766e"):(isDark?"#94a3b8":"#9ca3af"),boxShadow:tab===t.id?"0 1px 3px rgba(0,0,0,0.1)":"none"}}>
            {t.label}
          </button>
        ))}
      </div>
      {tab==="appointments"&&<Appointments clients={clients} setClients={setClients} theme={theme} userId={userId} profile={profile} appointments={appointments} setAppointments={setAppointments}/>}
      {tab==="attendance"&&<Attendance clients={clients} setClients={setClients} applyClientAndPayment={applyClientAndPayment} theme={theme} userId={userId} profile={profile} registerBack={registerBack} extRecords={extRecords} setExtRecords={setExtRecords} onRenewNeeded={handleRenewNeeded}/>}
      {tab==="batches"&&<BatchManager clients={clients} setClients={setClients} attendanceRecords={extRecords} theme={theme} userId={userId} profile={profile}/>}

      {/* Package complete prompt */}
      {renewNeeded&&!showRenew&&!showExtend&&(
        <div className="fixed inset-0 z-50 flex items-center justify-center px-6" style={{background:"rgba(0,0,0,0.5)"}}>
          <div className="rounded-2xl p-6 w-full max-w-xs shadow-2xl space-y-4" style={{background:isDark?"#1e293b":"#fff"}}>
            <div className="text-center space-y-2">
              <div className="text-3xl">📦</div>
              <p className="font-bold text-base" style={{color:isDark?"#f1f5f9":"#1f2937"}}>Package Complete</p>
              <p className="text-sm" style={{color:isDark?"#94a3b8":"#6b7280"}}>
                {renewNeeded.name}'s package is complete or expired. Please renew or extend to continue.
              </p>
            </div>
            <div className="flex flex-col gap-2">
              <Btn onClick={()=>setShowRenew(true)} theme={theme} className="w-full justify-center">🔄 Renew Package</Btn>
              {["monthly","quarterly","half_yearly","yearly","template_duration"].includes(renewNeeded.package?.type)&&(
                <Btn variant="ghost" onClick={()=>setShowExtend(true)} theme={theme} className="w-full justify-center">➕ Extend Package</Btn>
              )}
              <Btn variant="secondary" onClick={()=>setRenewNeeded(null)} theme={theme} className="w-full justify-center">Cancel</Btn>
            </div>
          </div>
        </div>
      )}

      {/* Renew Modal */}
      {renewNeeded&&showRenew&&(
        <RenewPackageModal
          client={renewNeeded}
          onClose={()=>{setShowRenew(false);setRenewNeeded(null);}}
          onRenew={({apply,payment})=>{const id=renewNeeded.id;setShowRenew(false);setRenewNeeded(null);applyClientAndPayment(id,apply,payment,toast);}}
          theme={theme} currency={currency} profile={profile}
        />
      )}

      {/* Extend Modal */}
      {renewNeeded&&showExtend&&(
        <ExtendPackageModal
          client={renewNeeded}
          onClose={()=>{setShowExtend(false);setRenewNeeded(null);}}
          onExtend={({apply,payment})=>{const id=renewNeeded.id;setShowExtend(false);setRenewNeeded(null);applyClientAndPayment(id,apply,payment,toast);}}
          theme={theme} currency={currency}
        />
      )}
    </div>
  );
};
